export default "__VITE_ASSET__9cdc3adf__"